export const AREA_STRUCTURE_DROPDOWN_OPTIONS = [
    { text: 'Option 1 (Orchard, Mgnt Areas, Blocks)', value: 1, key: 1 },
    { text: 'Option 2 (Sectors, Orchards, Lots, Blocks)', value: 2, key: 2 }
];
